<div class="action-buttons-section mt-4">
  <p-button
    type="button"
    label="Submit"
    styleClass="!max-w-[100px] !min-w-[100px] !bg-taxpod-blue !border-taxpod-blue !font-lato !font-bold !text-base  disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
    [disabled]="submitDisabled || isSubmitting"
    [loading]="isSubmitting"
    (click)="submit.emit()"
  ></p-button>

  <p-button
    label="Cancel"
    variant="text"
    styleClass="!max-w-[100px] !min-w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !text-sm xlplus:!text-base hover:!bg-[#E0F2FE] disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
    [disabled]="cancelDisabled"
    (click)="cancel.emit()"
  ></p-button>

  <p-button
    label="Delete"
    variant="text"
    severity="danger"
    (click)="delete.emit()"
  >
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 0.5rem;">
      <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 0 1 1.334-1.334h2.666a1.333 1.333 0 0 1 1.334 1.334V4m2 0v9.333a1.333 1.333 0 0 1-1.334 1.334H4.667a1.333 1.333 0 0 1-1.334-1.334V4h9.334Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </p-button>

  <!--
    Projection slot for controls that belong in this row but are not part of
    the Submit/Cancel/Delete triad — today, the conversion-engine picker.

    It is a slot rather than an input on purpose. This component owns the row's
    ARRANGEMENT and takes pre-computed booleans so form state does not leak
    across the boundary (see the class docblock); giving it an options list and
    a fetch dependency would hand it a second reason to change. Hosts that need
    the picker project it in and keep their own disabled term, which genuinely
    differs between them — role 0 always enables it, role 1 gates on
    hasUnsubmittedChanges().
  -->
  <ng-content></ng-content>
</div>
